module.exports = __webpack_public_path__ + "static/media/google.a86b12df.jpg";